import React, { useState, useEffect } from 'react';
import { collection, query, where, getDocs } from 'firebase/firestore'; 
import { db } from '../../config/firebase-config';

const GlobalAdmins = () => {
    const [adminUsers, setAdminUsers] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const fetchAdmins = async () => {
            const q = query(collection(db, "users"), where("role", "in", ["admin", "super_admin"]));
            try {
                const snapshot = await getDocs(q);
                setAdminUsers(snapshot.docs.map(d => ({ id: d.id, ...d.data() })));
            } catch (error) { console.error("Admin fetch error:", error); } 
            finally { setIsLoading(false); }
        };
        fetchAdmins();
    }, []);

    return (
        <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden">
            {isLoading ? (<div className="p-12 text-center text-slate-400">Loading directory...</div>) : (
                <table className="w-full text-left">
                    <thead className="bg-slate-50 border-b border-slate-100">
                        <tr>
                            <th className="p-4 text-xs font-bold text-slate-400 uppercase">Name</th>
                            <th className="p-4 text-xs font-bold text-slate-400 uppercase">Email</th>
                            <th className="p-4 text-xs font-bold text-slate-400 uppercase">Role</th>
                            <th className="p-4 text-xs font-bold text-slate-400 uppercase">Organization ID</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-100">
                        {adminUsers.map(admin => (
                            <tr key={admin.id} className="hover:bg-slate-50 transition-colors">
                                <td className="p-4 font-bold text-slate-700">{admin.name || "Unknown"}</td>
                                <td className="p-4 text-sm text-slate-600 font-mono">{admin.email}</td>
                                <td className="p-4"><span className={`px-2 py-1 rounded text-xs font-bold uppercase ${admin.role === 'super_admin' ? 'bg-purple-100 text-purple-700' : 'bg-blue-100 text-blue-700'}`}>{admin.role}</span></td>
                                <td className="p-4 text-sm text-slate-400 font-mono">{admin.organizationId || "Global"}</td>
                            </tr>
                        ))}
                        {adminUsers.length === 0 && (<tr><td colSpan="4" className="p-8 text-center text-slate-400">No admin users found.</td></tr>)}
                    </tbody>
                </table>
            )}
        </div>
    );
};

export default GlobalAdmins;